// English translation
import { en as views_en } from "./views";

const en = {
  "app.global.spanish": "Spanish",
  "app.global.english": "English",
  "login.welcome": "Welcome!",
  "login.start_session": "START SESSION",
  "login.invalid_user_password": "Invalid user or password!",
  "login.button_enter": "ENTER",
  "login.password": "PASSWORD",
  "login.database": "DATABASE",
  "login.username": "USERNAME",
  "login.forgot_password": "Forgot password?",
  "board.loading_please_wait": "Loading... Please one moment!",
  "board.loading": "Loading...",
  "board.approve": "APPROVE",
  "board.button_edit": "EDIT",
  button_edit: "Edit",
  "board.button_add": "ADD",
  button_add: "Add",
  "board.button_back": "BACK",
  "board.button_save": "SAVE",
  "board.button_remove": "REMOVE",
  "board.button_replace": "REPLACE",
  "board.filter": "FILTER",
  "board.button_confirm": "CONFIRM",
  "board.chart.in_thousands": "In thousands",
  "board.chart.see_report": "See Report",
  "board.sheet_select": "Spread Sheet",
  "board.missing_required_fields": "Missing required fields!",
  "quicktable.select_all": "ALL",
  missing_required_fields: "Missing required fields!",
  "board.records_found": "Records found",
  "board.records_saved": "RECORDS SAVED!",
  "board.record_created": "RECORD CREATED!",
  "board.dialog.button_discard": "Discard",
  "basic_modal.button_cancel": "CANCEL",
  "basic_modal.button_ok": "OK",
  "basic_modal.button_accept": "Accept",
  "basic_modal.button_close": "Close",
  "basic_modal.button_create": "Create",
  available: "Available",
  not_available: "Not Available",
  select_time: "Select the time...",
  "form_cloud_image.add_photo": "Add image",
  "menu.dashboard": "DASHBOARD",
  "menu.dashboard_melhous": "MELHOUS",
  "menu.delivery": "DOMICILIOS",
  "menu.order": "PEDIDOS",
  "menu.sale_order": "SALE ORDER",
  "menu.housekeeping": "HOUSEKEEPING",
  "menu.rest_order": "REST. ORDER",
  "menu.sales": "SALES",
  "menu.invoices": "INVOICES",
  "menu.reports": "REPORTS",
  "menu.request": "REQUEST",
  "menu.add_request": "ADD REQUEST",
  "menu.staff_supply_product": "SUPPLY PRODUCT",
  "menu.staff_supply_indicators": "SUPPLY INDICATORS",
  "menu.opportunity": "OPPORTUNITY",
  "menu.prospect": "PROSPECT",
  "menu.activity": "ACTIVITY",
  "menu.travel_person": "TRAVEL PERSON",
  "menu.ticket": "TURNADOR",
  "menu.affiliates": "AFILIADOS",
  "menu.assistant_control": "CONTROL DE ACCESO",
  "menu.sale_call_center": "ORDER RECORD",
  "sale.sale.number": "NUMBER",
  "sale.sale.sale_date": "DATE",
  "sale.sale.consumer": "CONSUMER",
  "sale.sale.position": "POSITION",
  "sale.sale.channel": "CHANNEL",
  "sale.sale.delivery_state": "STATUS",
  "sale.sale.comment": "COMMENT",
  "sale.sale.party": "PARTY",
  "sale.sale.waiting_time": "WAITING TIME",
  "sale.sale.order_status": "STATUS",
  "sale.sale.commanded": "COMMANDED",
  "sale.sale.draft": "DRAFT",
  "sale.sale.billing": "BILLING",
  "sale.sale.invoice_number": "Invoice Number",
  "sale.sale.pay": "PAY",
  "sale.sale.dispatched": "DISPATCHED",
  "sale.sale.rejected": "REJECTED",
  "sale.sale.delivered": "DELIVERED",
  "sale.sale.processing": "PROCESSING",
  "sale.sale.terminal": "TERMINAL",
  "sale.sale.gateway": "PASARELA",
  "sale.sale.total_amount": "TOTAL",
  "sale.sale.source": "SOURCE",
  "sale.sale.description": "DESCRIPTION",
  "sale.sale.description.report": "Sale Report",
  "sale.sale.state": "STATE",
  "sale.sale.notes": "Notes",
  "sale.sale.notifications": "Notifications",
  "notes.unread": "Unread",
  "notes.read": "Read",
  "notes.mark_all_read": "Mark all as read",
  "sale.sale.payment_method": "PAYMENT",
  "sale.sale.cash": "CASH",
  "sale.sale.persons": "Persons",
  "sale.sale.shipping_date": "Shipping_date",
  "sale.line.product": "PRODUCT",
  "sale.line.quantity": "QTY",
  "sale.line.discount": "DISCOUNT",
  "sale.line.unit_price": "UNIT PRICE",
  "sale.line.unit": "UNIT",
  "sale.line.unit_price_w_tax": "UNIT PRICE",
  "sale.line.sale_price_taxed": "UNIT PRICE W.TAX",
  "sale.line.amount": "AMOUNT",
  "sale.line.button_tag": "Tags",
  "sale.sale.quote": "Quote",
  "sale.sale.salesman": "SALESMAN",
  "sale.sale.shipment_address": "SHIP. ADDRESS",
  "sale.sale.agent": "AGENT",
  "sale.sale": "SALE",
  "sale.line": "PRODUCTS",
  button_cancel: "CANCEL",
  successful_order: "SUCCESSFUL ORDER!",
  "sale.sale.price_list": "PRICE LIST",
  button_delete: "DELETE",
  "sale.sale.shipment_date": "SHIP. DATE",
  "sale.sale.today": "TODAY",
  "menu.stock_request": "STOCK REQUEST",
  "menu.inventory": "INVENTORY",
  "stock.inventory": "INVENTORY",
  "stock.inventory.line": "LINES",
  "menu.purchase_requisition": "REQUISITION",
  "stock.shipment.internal": "INTERNAL REQUEST",
  "stock.shipment.internal.reference ": "REFERENCE",
  "stock.shipment.internal.from_location": "FROM LOCATION",
  "stock.shipment.internal.to_location": "TO LOCATION",
  "stock.shipment.internal.requested_by": "REQUESTED BY",
  "stock.shipment.internal.moves": "PRODUCTS",
  "stock.shipment.internal.state": "STATE",
  "stock.shipment.internal.number": "NUMBER",
  "stock.shipment.internal.effective_date": "EFFECTIVE DATE",
  "stock.shipment.internal.today": "TODAY",
  "stock.shipment.internal.wait": "CONFIRM",
  "stock.shipment.internal.request": "REQUESTED",
  "stock.shipment.internal.request_button": "REQUEST",
  "stock.shipment.internal.assign": "ASSIGN",
  "stock.shipment.internal.shipped": "SHIPPED",
  "stock.shipment.internal.ship": "SHIP",
  "stock.shipment.internal.planned_start_date": "Fecha De Envio Planeada",
  "stock.shipment.internal.partial_receive_completed":
    "Partial receive completed. New shipment: {number}",
  "stock.shipment.internal.print": "Imprimir",
  "stock.shipment.internal.notifications": "Notifications",
  "stock.shipment.internal.notes": "Notifications",
  effective_date: "PLAN. DATE",
  uom: "UoM",
  default_uom: "UoM",
  "stock.move": "PRODUCTS",
  "stock.move.product": "PRODUCT",
  "stock.move.uom": "UOM",
  "stock.move.quantity": "QUANTITY",
  waiting: "WAITING",
  request: "REQUEST",
  billing: "BILLING",
  print: "PRINT",
  user_has_not_access_permissions: "User has not access permissions!",
  "purchase.purchase.purchase_date": "DATE",
  "purchase.purchase.number": "NUMBER",
  "purchase.purchase.approved": "APPROVED",
  "purchase.purchase.confirmed": "CONFIRMED",
  "purchase.purchase.done": "DONE",
  "purchase.purchase.processing": "PROCESSING",
  "purchase.purchase.cancelled": "CANCELLED",
  "purchase.purchase.total_amount": "TOTAL AMOUNT",
  "purchase.purchase.party": "PARTY",
  "purchase.purchase.state": "STATE",
  "purchase.purchase.project": "PROJECT",
  "purchase.purchase.create_uid": "USER",
  "purchase.purchase.description": "DESCRIPTION",
  "purchase.purchase.payment_term": "PAYMENT TERM",
  "purchase.purchase.reference": "REFERENCE",
  "purchase.purchase.untaxed_amount": "UNTAXED AMOUNT",
  "purchase.purchase.tax_amount": "TAX AMOUNT",
  "purchase.purchase.comment": "COMMENT",
  "purchase.purchase.today": "TODAY",
  "purchase.purchase": "PURCHASE",
  "purchase.purchase.pending": "PENDING",
  "purchase.purchase.all": "ALL",
  "purchase.purchase.quotation": "QUOTATION",
  "purchase.purchase.draft": "DRAFT",
  "menu.purchase": "PURCHASE",
  "menu.purchase_approval": "PURCHASE APPROVAL",
  "menu.shipment_internal": "SHIPMENT INTERNAL",
  "menu.shipment_internal_qr": "SHIPMENT INTERNAL QR",
  "purchase.line": "PRODUCTS",
  "product.code": "CODE",
  "product.description": "DESCRIPTION",
  "menu.surveillance_schedule": "Surveillance",
  "surveillance.schedule": "Surveillance",
  supplier: "SUPPLIER",
  code: "CODE",
  employee: "EMPLOYEE",
  active: "ACTIVE",
  city: "CITY",
  name: "NAME",
  position: "POSITION",
  "board.button_reload": "RELOAD",
  successful: "SUCCESSFUL TRANSACTION!",
  total_amount_cache: "TOTAL AMOUNT",
  untaxed_amount_cache: "SUBTOTAL",
  tax_amount_cache: "IMPUESTOS",
  high: "Alta",
  urgent: "Urgente",
  low: "Baja",
  "purchase.purchase.priority": "PRIORITY",
  "purchase.purchase.approval": "APPROVAL",
  "purchase.purchase.approval_user": "APROBADO POR",
  "purchase.purchase.approval_date": "FECHA APROBAC.",
  "purchase.purchase.approval_signature": "APPROVED BY",
  "purchase.purchase.authorize": "AUTHORIZE",
  "purchase.purchase.authorized_user": "AUTHORIZE USER",
  "purchase.purchase.authorized_signature": "AUTHORIZE BY",
  "purchase.purchase.confirm": "CONFIRM",
  "purchase.purchase.confirmation_signature": "CONFIRMED BY",
  "purchase.purchase.confirm_user": "CONFIRMADO POR",
  "purchase.line.product": "PRODUCT",
  "purchase.line.unit_price": "UNIT_PRICE",
  "purchase.line.amount": "AMOUNT",
  "purchase.line.quantity": "QUANTITY",
  "purchase.line.description": "DESCRIPTION",
  "menu.hotel_planner": "PLANNER",
  "menu.hotel_calendar": "CALENDAR",
  "menu.take_order": "TOMA DE PEDIDO",
  "menu.order_viewer": "VISOR DE ORDENES",
  table_assigned: "MESA",
  command: "COMANDAR",
  note: "NOTA",
  order_sended: "Comm.",
  "sale.line.note": "Notes",
  "sale.line.requested": "Requested",
  "sale.line.draft": "Draft",
  "sale.line.commanded": "Comman.",
  "room.none": "None",
  "room.blocked": "Blocked",
  "room.check_in": "Check-In",
  "room.check_out": "Check-Out",
  "room.maintenance": "Maintenance",
  "room.pending": "Pending",
  "menu.self_service_sale": "SELF SALE",
  "app.webcheckin": "WEB CHECK IN",
  "menu.web_checkin": "WEB CHECK IN",
  "app.webcheckin.DIRECTO": "Directo",
  "hotel.folio.guest.cedula_de_ciudadania": "Cedula de Ciudadania",
  "hotel.folio.guest.pasaporte": "Passport",
  "hotel.folio.guest.tarjeta_de_identidad": "Tarjeta de Identidad",
  "hotel.folio.guest.tarjeta_de_extranjeria": "Tarjeta de Extranjeria",
  "hotel.folio.guest.cedula_de_extranjeria": "Cedula de Extranjeria",
  male: "Male",
  female: "Female",
  finish: "FINISH",
  webcheckin_success_msg:
    "Congratulations, now your check-in will be much faster at our hotel, and from now on you will be able to enjoy our Premiun services.",
  webcheckin_success_header: "Success Registration!!!",
  webcheckin_success_our_services: "Our Services",
  webcheckin_booking_page:
    "You can now add guests to each of your booked rooms, every time you want to add a person clicked on the room.",
  male: "Male",
  female: "Female",
  cedula_ciudadania: "National ID Card",
  pasaporte: "Passport",
  tarjeta_identidad: "Identity Card",
  tarjeta_extranjeria: "Foreigner ID Card",
  cedula_extranjeria: "Foreigner ID",
  adult: "Adulto",
  child: "Niño/a",
  type: "TYPE",
  link: "LINK",
  file: "FILE",
  "menu.charts": "Dashboard",
  sales: "Sales",
  payroll: "Payroll",
  hotel: "Hotel",
  crm: "CRM",
  purchases: "Purchases",
  dashboard: "Dashboard",
  go_back: "GO BACK",
  address: "ADDRESS",
  country_residence: "COUNTRY OF RESIDENCE",
  unit: "UNIT",
  company: "Company",
  user: "User",
  password: "Password",
  enter: "Enter",
  "modal_msg.record_successful": "Registration entered correctly!",
  "modal_msg.record_warning": "Adverencia!",
  "modal_msg.record_ask": "Pregunta",
  "modal_msg.record_error": "Error de Registro",
  "crm.customer_service.addres": "Dirección",
  "crm.customer_service.search": "Buscar",
  "crm.customer_service.case": "Detalle Causal",
  "crm.customer_service.response": "Respuesta",
  "crm.customer_service.description": "Resumen de Solicitud",
  "crm.customer_service.state": "Estado",
  "crm.customer_service.party": "Name",
  "crm.customer_service.cs_date": "Date",
  "crm.customer_service.number": "Número de Radicado",
  "crm.customer_service.party_id_number": "Número de Identificación",
  "crm.customer_service.draft": "Radicado",
  "crm.customer_service.open": "Abierto",
  "crm.customer_service.close": "Cerrado",
  "crm.customer_service.email": "Email",
  "crm.customer_service.attach_customer_1": "Adjunto",
  "crm.customer_service.create_service": "CREAR RADICADO",
  "crm.customer_service.ethnical_group": "Grupo Étnico",
  "crm.customer_service.special_population": "Poblacón Especial",
  "crm.customer_service.personal_information": "Información Personal",
  "crm.customer_service.pqrs_information": "Información PQRS",
  "crm.customer_service.demographic_information":
    "Información Sociademografica",
  "crm.customer_service.description_facts": "Descripción de los Hechos",
  "crm.customer_service.phone": "Phone",
  "crm.customer_service.health_provider": "Prestador de Salud",
  "crm.customer_service.detailed_especific_1": "Detalle Especifico",
  "form_modal.button_close": "CLOSE",

  button_open: "OPEN",
  "board.dialog.button_close": "Cerrar",
  "board.dialog.button_ok": "OK",
  "board.dialog.button_cancel": "Cancel",
  "planner.date": "Date",
  "hotel.folio.meal_plan": "Meal Plan",
  "hotel.folio.pending_total": "Pending Total",
  "hotel.folio.agent": "Agent",
  "hotel.folio.unit_price_w_tax": "Precio con Imp.",
  "hotel.folio.vehicle_plate": "Vehicle Plate",
  "hotel.folio.guests": "Guests",
  "hotel.folio.payment_status": "Payment Status",
  "hotel.folio.charge": "Charges",
  "hotel.folio.charge.description": "Description",
  "hotel.folio.charges": "Charges",
  "hotel.folio.guest": "Guest",
  "hotel.folio.guest.main_guest": "ain Guest",
  "hotel.folio.guest.name": "Name",
  "hotel.folio.guest.type_document": "Type Document",
  "hotel.folio.guest.id_number": "Id Number",
  "hotel.folio.guest.mobile": "Mobile",
  "hotel.folio.guest.email": "Email",
  "hotel.folio.guest.address": "Address",
  "hotel.folio.guest.nationality": "Nationality",
  "hotel.folio.guest.origin_country": "Origin Country",
  "hotel.folio.guest.target_country": "Target Country",
  "hotel.folio.guest.birthday": "Birthday",
  "hotel.folio.guest.notes": "Notes",
  "hotel.folio.guest.visa_date": "Visa Date",
  "hotel.folio.guest.visa_number": "Visa Number",
  "hotel.folio.guest.sex": "Sexo",
  "hotel.folio.guest.profession": "Profesion",
  "hotel.folio.guest.registro_civil": "Registro Civil de Nacimiento",
  "hotel.folio.guest.tarjeta_identidad": "Tarjeta de Identidad",
  "hotel.folio.guest.cedula_ciudadania": "Cedula de Ciudadania",
  "hotel.folio.guest.tarjeta_extranjeria": "Tarjeta de Extranjeria",
  "hotel.folio.guest.cedula_extranjeria": "Cedula de Extranjeria",
  "hotel.folio.guest.nit": "NIT",
  "hotel.folio.guest.add_guest": "Add",
  "hotel.folio.guest.cancel": "Cancel",
  "hotel.folio.guest.tipo_documento_extranjero": "Tipo de Documento Extranjero",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "NIT de otro pais",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "Country",
  "hotel.folio.guest.subdivision": "Subdivision",
  "hotel.folio.guest.clone_holder": "Create Guest",
  "hotel.folio.charge.sale_date": "Date",
  "hotel.folio.charge.product": "Product",
  "hotel.folio.charge.quantity": "Quantity",
  "hotel.folio.charge.unit_price_w_tax": "Unit Price W Tax",
  "hotel.folio.charge.amount": "Amount",
  "hotel.folio.charge.status": "Status",
  "hotel.folio.charge.pending": "Pending",
  "hotel.folio.charge.add_product": "Add Product",
  "app.webcheckin.customer": "CUSTOMER",
  "app.webcheckin.no_booking": "No. BOOKING",
  "app.webcheckin.channel": "CHANNEL",
  "app.webcheckin.arrival_date": "ARRIVAL DATE",
  "app.webcheckin.departure_date": "DEPARTURE DATE",
  "app.webcheckin.finish": "FINISH",
  "app.webcheckin.direct": "DIRECT",
  "app.webcheckin.main_guest": "ARE YOU MAIN GUEST?",
  "app.webcheckin.name": "NAME",
  "app.webcheckin.mobile": "MOBILE",
  "app.webcheckin.email": "EMAIL",
  "app.webcheckin.address": "ADDRESS",
  "app.webcheckin.nationality": "NATIONALITY",
  "app.webcheckin.country_residence": "COUNTRY RESIDENCE",
  "app.webcheckin.sex": "SEX",
  "app.webcheckin.type_guest": "TYPE GUEST",
  "app.webcheckin.id_number": "ID NUMBER",
  "app.webcheckin.type_document": "DOCUMENT TYPE",
  "app.webcheckin.visa_number": "No VISA",
  "app.webcheckin.visa_date": "EXPIRATION VISA DATE",
  "app.webcheckin.birthday": "BIRTHDAY",
  "app.webcheckin.profession": "PROFESSION",
  "app.webcheckin.add_guest": "ADD GUEST",
  "app.webcheckin.cancel": "CANCEL",
  "surveillance.location.code": "CODE",
  "surveillance.location.name": "NAME",
  "surveillance.location.customer": "CUSTOMER",
  "surveillance.location.city": "CITY",
  "schedule.scheduling": "SCHEDULING",
  "surveillance.schedule.shift": "Shift",
  "surveillance.schedule.shift.guard": "Guard",
  "surveillance.schedule.shift.location": "Location",
  "surveillance.schedule.shift.shift_date": "Fecha",
  "surveillance.schedule.shift.replicate": "Replicar",
  "surveillance.schedule.shift.extra_shift": "Turno Extra",
  "surveillance.schedule.shift.shift": "Clase de Turno",
  "surveillance.schedule.shift.duration": "Duracion",
  "surveillance.schedule.shift.enter_dtime": "Ingreso",
  "surveillance.schedule.shift.exit_dtime": "Salida",
  "surveillance.schedule.shift.position": "Posicion",
  "surveillance.schedule.shift.event_category": "Novedad Prog.",
  "surveillance.schedule.shift.event": "Novedad Efectiva",
  "surveillance.schedule.shift.notes": "Notas",
  "surveillance.schedule.shift.event_start_date": "Inicio de Novedad",
  "surveillance.schedule.shift.event_end_date": "Fin de Novedad",
  "surveillance.schedule.shift.kind": "Turno",
  "surveillance.schedule.shift.state": "Estado",
  "surveillance.schedule.shift.guard.photo_link": "Photo",
  "surveillance.schedule.shift.draft": "Draft",
  "surveillance.schedule.shift.performed": "Performed",
  "surveillance.schedule.shift.schedule": "Schedule",
  "surveillance.schedule.state": "State",
  "surveillance.schedule.draft": "Draft",
  "surveillance.schedule.planned": "Planned",
  "schedule.shift": "SHIFT",
  "schedule.search": "Search",
  "company.employee.party": "Employee",
  "company.employee.code": "Code",
  "modal.search": "SEARCH",
  "surveillance.schedule.period": "Period",
  "surveillance.schedule.location": "Location",
  "crm.opportunity.state": "State",
  "crm.opportunity.agent": "Agent",
  "crm.opportunity.party_contact": "Party Contact",
  "crm.opportunity.party_category": "Category",
  "crm.opportunity.contact_phone": "Phone",
  "crm.opportunity.state.lead": "Lead",
  "crm.opportunity.state.opportunity": "Opportunity",
  "crm.opportunity.city": "City",
  "crm.opportunity.conversion_probability": "Conversion Probability",
  "crm.opportunity.lead_origin": "Origin",
  "crm.opportunity.amount": "Amount",
  "crm.opportunity.type": "Type",
  "crm.opportunity.prospect": "Prospect",
  "crm.opportunity.end_date": "End Date",
  "crm.opportunity.line.payment_term": "Payment Term",
  "crm.opportunity.line.description": "Description",
  "crm.opportunity.line.billing_frecuency": "Billing",
  "crm.opportunity.line.unit": "Unit",
  "crm.opportunity.line.availability": "Availability",
  "crm.opportunity.brochure": "Brochure",
  "crm.opportunity.company": "Company",
  "crm.opportunity.contact_email": "Contact Email",
  "crm.opportunity.more_probabilty": "More Probabilty",
  "crm.opportunity.last_90": "Ultimos 90 dias",
  "crm.opportunity.last_quotations": "Last Quotations",
  "crm.opportunity.panel.win_rate": "Win Rate",
  "crm.opportunity.panel.win_rate_today": "Today",
  "crm.opportunity.panel.win_rate_yesterday": "Yesterday",
  "crm.opportunity.panel.activities_today": "Activ. Today",
  "crm.opportunity.panel.activities_tomorrow": "Activ. Tomorrow",
  "crm.opportunity.panel.activities_pending": "Activ. Pending",
  "crm.opportunity.panel.leads": "Leads",
  "crm.opportunity.panel.leads_draft": "Draft",
  "crm.opportunity.panel.leads_convert": "Convert",
  "crm.opportunity.sales.sale_date": "Sale Date",
  "crm.prospect.name": "Name",
  "crm.prospect.phone": "Phone",
  "crm.prospect.email": "Email",
  "crm.prospect.agent": "Agent",
  "crm.prospect.country": "Country",
  "crm.prospect.company": "Company",
  "crm.activity": "Activity",
  "crm.activity.On-Site Appointment": "On-Site Appointment",
  "crm.activity.Virtual Appointment": "Virtual Appointment",
  Action: "Action",
  Call: "Call",
  Email: "Email",
  "crm.activity.subject": "Subject",
  "crm.activity.planned_date": "Planned Date",
  "crm.activity.effective_date": "Effective Date",
  "crm.activity.duration": "Duration",
  "crm.activity.agent": "Agent",
  "crm.activity.type_": "Type",
  "crm.activity.description": "Description",
  "crm.opportunity.description": "Description",
  "crm.opportunity": "Opportunity",
  "crm.opportunity.lead": "Lead",
  "crm.opportunity.opportunity": "Opportunity",
  "crm.opportunity.converted": "Converted",
  "crm.opportunity.won": "Won",
  "crm.opportunity.lost": "Lost",
  "crm.opportunity.cancelled": "Cancelled",
  "crm.opportunity.party_category.filter": "Party Category",
  "crm.opportunity.start_date.filter": "Start Date",
  "crm.opportunity.lead_origin.filter": "Lead Origin",
  "crm.opportunity.city.filter": "City",
  "On-Site Appointment": "On-Site Appointment",
  "Virtual Appointment": "Virtual Appointment",
  "crm.opportunity.number": "Number",
  "crm.opportunity.party": "Party",
  "crm.opportunity.start_date": "Start Date",
  "crm.activity.state": "State",
  "crm.opportunity.line": "Lines",
  "crm.opportunity.line.product": "Product",
  "crm.opportunity.line.quantity": "Quantity",
  "crm.opportunity.line.unit_price": "Unit Price",
  "crm.opportunity.payment_term": "Payment Term",
  "crm.opportunity.comment": "Comment",
  "crm.activity.done": "Done",
  "crm.activity.planned": "Planned",
  "crm.activity.rescheduled": "Rescheduled",
  "crm.activity.customer": "Customer",
  crm_opportunities_title: "Opportunities",
  crm_prospects_title: "Propects",
  crm_activities_title: "Activities",
  button_start: "Start",
  crm_name: "Customer Management | CRM",
  crm_opportunities_desc: "Follow up on business opportunities.",
  crm_prospects_desc:
    "Follow up with your customers from the very first contact.",
  crm_activities_desc: "Follow up on business activities.",
  "menu.crm_sales": "CRM",
  "crm.prospect": "Prospect",
  "modal_form.button_accept": "Accept",
  "modal_form.button_add": "Add",
  "modal_form.button_save": "Save",
  "board.button_field_create": "Create",
  "board.button_field_edit": "Edit",
  "party.party.id_number": "ID Number",
  "party.party.type_document": "Type Document",
  "party.party.nationality": "Nationality",
  "party.party.main_email": "Email",
  "party.party.main_mobile": "Mobile",
  "party.party.phone": "Phone",
  "party.party.sex": "Sex",
  "party.party.birthday": "Birthday",
  "party.party": "Add Customer",
  "party.party.street": "Street",
  "party.party.account_receivable": "Account Receivable",
  "party.party.country": "Country",
  "party.party.subdivision": "Subdivision",
  "party.party.city": "City",
  holder: "Holder",
  holder_guest: "Holder / Guest",
  guest: "Guest",
  no_breakfast: "No Breakfast",
  all_inclusive: "All Inclusive",
  bed_breakfast: "Bed Breakfast",
  full_american: "Full American",
  half_american: "Half American",
  "menu.activity": "Activities",
  "menu.opportunity": "Opportunities",
  "menu.prospect": "Prospects",
  "sale_activity.activity.time_start": "Time Start",
  "sale_activity.activity.time_end": "Time End",
  "sale_activity.activity.available": "Available",
  "sale_activity.activity.quota": "Quota",
  "sale_activity.activity.state": "State",
  "sale_activity.activity.add": "Add",
  "sale_activity.activity.employee": "Employee",
  "sale.sale.add_courtesy": "Add Courtesy",
  all: "All",
  partial: "Partial",
  "maintenance.equipment.code": "Code",
  "maintenance.equipment.gps_link": "Gps link",
  "maintenance.equipment.gps_passwd": "Gps password",
  "maintenance.equipment.brand": "Brand",
  "maintenance.equipment.type_device": "Type device",
  "maintenance.equipment.date_return": "Date return",
  "maintenance.equipment.status": "Status",
  "maintenance.equipment.available": "Available",
  "maintenance.equipment.maintenance": "Maintenance",
  "maintenance.equipment.not_available": "No available",
  "maintenance.equipment.stolen": "Stolen",
  "maintenance.request_service.effective_date": "Effective_date",
  "maintenance.request_service.type_activity": "Activity type",
  "maintenance.equipment.party": "Party",
  "maintenance.equipment.equipment": "Equipment",
  "maintenance.request_service.kind": "Kind",
  "maintenance.request_service.piece": "Piece",
  "maintenance.request_service.equipment": "equipment",
  "maintenance.request_service.request_date": "Request date",
  "maintenance.check_list.quantityy": "quantity",
  "maintenance.check_list_equipment.notes": "Description",
  "maintenance.request_service.open": "Open",
  "maintenance.request_service.assigned": "Assigned",
  "maintenance.request_service.done": "Done",
  "maintenance.request_service.no_approved": "No approved",
  "maintenance.request_service.approved": "Approved",
  "maintenance.request_service.action": "Action",
  "maintenance.request_service.cancelled": "Cancelled",
  "maintenance.request_service.waiting_approval": "Waiting",
  "maintenance.request_service.marked": "Marked",
  "maintenance.request_service.efficacy": "Efficacy",
  "board.button.add": "Add",
  driver_license: "Driver License",
  passport: "Passport",
  medicare_card: "Medicare Card",
  phone: "phone",
  fax: "fax",
  email: "email",
  chat: "chat",
  walking: "walking",
  web: "web",
  channel_manager: "channel_manager",
  ota: "ota",
  "rest_order.options": "Opciones",
  "rest_order.search_products": "Search product...",
  "rest_order.no_results": "No results",
  "surveillance.schedule_month.report.period": "Period",
  "surveillance.schedule_month.report.location": "Location",
  "surveillance.schedule_month.report": "Compliance Report",
  "maintenance.equipment.state": "State",
  "maintenance.equipment.excelñent": "Excellent",
  "maintenance.equipment.good": "Good",
  "maintenance.equipment.acceptable": "Acceptable",
  "maintenance.equipment.bad": "Bad",
  "maintenance.equipment.product": "Product",
  "maintenance.equipment.active": "Active",
  "maintenance.equipment.gps_serial": "Gps serial",
  "maintenance.equipment.serial": "Serial",
  "maintenance.equipment.vin": "Vin",
  "maintenance.equipment.model_num": "Model num",
  "maintenance.equipment": "EQUIPMENT AND INSTRUMENT",
  "menu.maintenance": "EQUIPMENT AND INSTRUMENT",
  "menu.rentalb": "BOOKING",
  monthly: "Monthly",
  one_payment: "One Payment",
  bimonthly: "One Payment",
  biannual: "Biannual",
  annual: "Annual",
  "crm.customer_service": "Filing form",
  "sale.sale.confirmed": "Confirmado",
  "sale.sale.party.mobile": "Movil",
  "sale.sale.party.name": "Cliente",
  "party.addresses": "Direcciones",
  "party.addresses.street": "Calle",
  "party.addresses.country_code": "Pais",
  "party.addresses.department_code": "Departamento",
  "party.addresses.city_code": "Ciudad",
  "party.contact_mechanisms": "Metodos de contacto",
  "party.contact_mechanisms.type": "Tipo",
  "party.contact_mechanisms.name": "Nombre",
  "party.contact_mechanisms.value": "Dato de contacto",
  "sale.sale.party.id_number": "N° Documento",
  "date_range.select": "Select",
  "date_range.filter_date": "Date to filter",
  "sale.sale.reference": "Reference",
  "sale.sale.month": "Month",
  "sale.sale.month_3": "3 Month",
  "sale.sale.month_6": "6 Month",
  "sale.sale.printBrowser": "Print",
  agent: "Agent",
  news: "News",
  leads: "Leads",
  opportunity: "Opportunity",
  won: "Won",
  lost: "Lost",
  cancelled: "Cancelled",
  amount: "Amount ",
  success_rate: "Success Rate",
  product: "Product",
  accomodation: "Accommodation",
  "crm.person": "Acompañantes",
  "crm.person.name": "Nombre",
  "crm.person.id_number": "Num. Id",
  "crm.person.phone": "Telefono",
  "crm.person.email": "Correo",
  "sale.line.person": "Acompañantes",
  "sale.line.person.name": "Nombre",
  "sale.line.person.id_number": "Num. Id",
  "sale.line.person.phone": "Telefono",
  "sale.line.person.email": "Correo",
  "sale.line.person.arrival_date": "Arrival Date",
  "sale.line.person.today": "Hoy",
  "sale.line.person.month": "Mes",
  "sale.line.person.week": "Semana",
  "sale.line.person.line": "Servicio",
  "sale.line.person.sale": "Venta",
  "web.booking.avalaible": "Available",
  "web.booking.occupation": "Occupation",
  "web.booking.minimum_stay": "Minimium stay",
  "app.booking.name": "Name",
  "app.booking.lastname": "Last name",
  "app.booking.add_pay": "Add payment",
  "app.booking.sex": "Gender",
  "app.booking.type_document": "Document type",
  "app.booking.id_number": "N° Document",
  "app.booking.mobile": "Phone",
  "app.booking.email": "Email",
  "app.booking.address": "Address",
  "app.booking.btn-form": "RESERVE",
  "app.booking.btn-form-payment": "CHECKOUT",
  "app.booking.country": "Country",
  "app.booking.department": "Department",
  "app.booking.city": "City",
  "app.booking.msg_nodata": "No rooms available",
  "app.booking.msg_minimum_stay":
    "A minimum stay of {nights} nights is required for the requested dates.",
  "app.booking.msg_nodate": "Select Check-In and Check-Out",
  "app.booking.note": "Note",
  "menu.account_statement": "ACCOUNT STATEMENT",
  "web.booking.txt_iva": "Charges and taxes included",
  "app.booking.term_cond": "Terms & Conditions",
  "app.booking.privacy": "Privacy Policy",
  "sale_pos.money_count.bill": "Bill",
  "sale_pos.money_count.quantity": "Quantity",
  "sale_pos.money_count.amount": "Amount",
  "sale_pos.money_count.total": "Total",
  "app.booking.redirect": "You are being redirected to payment...",
  "app.booking.label_form": "Add the owner's information",
  "app.booking.label_aside": "Your Reservation",
  "app.booking.btn_confirm": "CONFIRM",
  "app.booking.amount": "Total:",
  "app.booking.right_reserved": "All rights reserved",
  "app.booking.copyright": "Presik Copyright © 2026",
  "app.booking.validate_email": " Valid your email",
  "app.booking.create_reserve": "Reservation created",
  "app.booking.successfully": "successfully",
  "app.booking.alert_filter_date":
    "Select a Check-out date less than the Check-in date. ",
  "app.booking.alert_select_room": "Select a room type for your reservation.  ",
  "app.booking.date_payment": "Payment date",
  "app.booking.night": "Night",
  "app.booking.price": "PRICE",
  "app.booking.includes": "Includes",
  "app.booking.btn_reserve_item": "Add reservation",
  "app.booking.btn_add_coupon": "Add coupon",
  "app.booking.note_placeholder":
    "Dear guest, please write us your special requests.",
  "sale_pos.money_count": "Conteo de Dinero",
  "ticket_system.ticket.status": "Status",
  "ticket_system.ticket.waiting": "Waiting",
  "ticket_system.ticket.done": "Done",
  "ticket_system.ticket.busy": "Busy",
  "ticket_system.ticket.cancelled": "Cancelled",
  "ticket_system.ticket.turn": "# Turn",
  "ticket_system.ticket.number_id": "# Document",
  "ticket_system.ticket.position.number": "Position",
  "ticket_system.ticket.state": "State",
  "ticket_system.ticke_not_found": "There are no shifts in waiting status",
  "ticket_system.ticket.add_turn": "You must assign yourself a turn",
  "ticket_system.ticket.next_turn": "NEXT TURN",
  "ticket_system.ticket.take_turn": "TAKE TURN",
  "ticket_system.ticket.finish_turn": "END TURN",
  "ticket_system.ticket.currents_turn": "Cashier shift",
  "ticket_system.ticket.attention_schedule": "Attention schedule",
  "ticket_system.ticket.weekday": "Mon - Fri",
  "ticket_system.ticket.wekend": "Sat - Sun",
  "hotel.guest.you_can_not_clone_holder":
    "No puede crear automáticamente un huesped si antes no ha creado el titular",
  "account_statement_co.advanced_report": "Statement Advanced Report",
  "account_statement_co.advanced": "Statement Advanced Report",
  "account_statement_co.advanced.description":
    "Statement including all shops / environments",
  "account_statement_co.advanced.start.operation_center": "Operation Center",
  "account_statement_co.advanced.start.date": "Date",
  "account_statement_co.cash_up_report": "Cash Up Report",
  "account_statement_co.cash_up": "Cash Up Report",
  "account_statement_co.cash_up.description": "Cash Up individual report",
  "account_statement_co.cash_up.start.operation_center": "Date",
  "account_statement_co.cash_up.start.date": "Date",
  "account_statement_co.cash_up.start.shop": "Shop",
  "account_statement_co.cash_up.start.user": "User",
  "hotel.folio.guest.adult": "Adult",
  "hotel.folio.guest.child": "Child",
  add_header_modal: "Add",
  "booking.widget.screen.view_less": "View less",
  "booking.widget.screen.view_more": "View more",
  "hotel.folio.guest.transfer": "Transport",
  "hotel.folio.guest.notes_transfer": "Transport Notes",
  "hotel.folio.guest.cradle": "Cradle",
  "hotel.folio.guest.notes_cradle": "Cradle Notes",
  "hotel.folio.guest.pet": "Pet",
  "hotel.folio.guest.notes_pet": "Pet Notes",
  "menu.vps": "VPS",
  "party.party.born_country": "Nationality",
  "sale.lines.add_tags": "Add Tags",
  "sale.lines.skip_tags": "Skip tags",
};

const _en = { ...en, ...views_en };
export default _en;
